module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wiskey_851bfe.jpg";